import React, { useState } from "react";
import SidebarMenu from "./SidebarMenu";
import PersonalInformation from "./PersonalInformation";
import ChangePassword from "./ChangePassword";
import "../style/profilePage.css";
import Logout from "./Logout";

const ProfilePage = ({ user }) => {
  const [page, SetPage] = useState("1");
  return (
    <div className="farsi profile-page-container">
      <div className="side-bar-col ">
        <SidebarMenu pageFiller={(e) => SetPage(e)}></SidebarMenu>
      </div>

      <div className="left-element ">
        <div>
          <div>
            {page == "1" && (
              <PersonalInformation user={user}></PersonalInformation>
            )}
            {page == "2" && <ChangePassword user={user}></ChangePassword>}
            {page == "3" && <Logout></Logout>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
